import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../../Components/ProtectedRoute";
import ConsultantSubmissionsPage from "./ConsultantSubmissionsPage";
import ConsultantConsultationsPage from "./ConsultantConsultationsPage";
import ConsultantEmployerInquiriesPage from "./ConsultantEmployerInquiriesPage";

const ConsultantRoutes = (roleName, roleNames) => {
  const allowedRoles = ["CONSULTANT", "ADMIN", "ADMIN_DEVELOPER"];
  const userRoles = roleNames || [roleName];

  return (
    <>
      <Route
        path="/dashboard/consultant/employer-inquiries"
        element={
          <ProtectedRoute
            element={<ConsultantEmployerInquiriesPage />}
            allowedRoles={allowedRoles}
            userRoles={userRoles}
          />
        }
      />
      <Route
        path="/dashboard/consultant/submissions"
        element={
          <ProtectedRoute
            element={<ConsultantSubmissionsPage />}
            allowedRoles={allowedRoles}
            userRoles={userRoles}
          />
        }
      />
      <Route
        path="/dashboard/consultant/consultations"
        element={
          <ProtectedRoute
            element={<ConsultantConsultationsPage />}
            allowedRoles={allowedRoles}
            userRoles={userRoles}
          />
        }
      />
    </>
  );
};

export default ConsultantRoutes;
